import axios from 'axios'
const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage`;
const API_PATH_V2 = `${process.env.REACT_APP_ENV === 'local' ? '' : '/v2'}/manage/charging`;

// 充電管理 -> 充電明細
const getChargeReport = async (resource) =>
    await axios.get(`${API_PATH_V2}/detail`, { params: resource })
const getChargeRecord = async (resource) =>
    await axios.get(`${API_PATH_V2}/detail/${resource}/record`)
const getChargeReportExport = async (resource) =>
    await axios.get(`${API_PATH_V2}/detail/export`, { params: resource , responseType: 'blob' })
// 充電管理 -> 金流額度
const getPaymentParameter = async (resource) =>
    await axios.get(`${API_PATH}/charging/paymentParameter`, { params: resource })
const updatePaymentParameter = async (resource) =>
    await axios.put(`${API_PATH}/charging/paymentParameter`, resource)
// 充電管理 -> 特約廠商
const getCpo = async (resource) =>
    await axios.get(`${API_PATH}/charging/cpo`, { params: resource })
const createCpo = async (resource) =>
    await axios.post(`${API_PATH}/charging/cpo`, resource)
const updateCpo = async (resource) =>
    await axios.put(`${API_PATH}/charging/cpo`, resource)
const deleteCpo = async (resource) =>
    await axios.delete(`${API_PATH}/charging/cpo`, { data: resource })
// 充電管理 -> 紅利點數回饋
const getBonus = async (resource) =>
    await axios.get(`${API_PATH}/bonus`, { params: resource })
const postCreateBonus = async (resource) =>
    await axios.post(`${API_PATH}/bonus`, resource)
const postUpdateBonus = async (resource) =>
    await axios.put(`${API_PATH}/bonus`, resource)
const postDeleteBonus = async (resource) =>
    await axios.delete(`${API_PATH}/bonus`, { data: resource })
const importBonus = async resource => (
    await axios.post(`${API_PATH}/bonus/import`, resource, { headers: { "Content-Type": "multipart/form-data"} })
);
// 充電管理 -> 廠商傳輸紀錄
const getChargingCpoApiLog = async (resource) =>
    await axios.get(`${API_PATH}/charging/cpo/log`, { params: resource })
// 充電管理 -> 財務發票查詢
const getInvoice = async (resource) =>
    await axios.get(`${API_PATH}/invoice/detail`, { params: resource })
const postInvoiceReport = async (resource) =>
    await axios.post(`${API_PATH}/invoice/detail/report`, resource, { responseType: 'blob' })
// 充電管理 -> 財務交易查詢
const getInvoiceChargingForm = async (resource) =>
    await axios.get(`${API_PATH}/invoice/chargingForm`, { params: resource })
const postInvoiceChargingFormReport = async (resource) =>
    await axios.post(`${API_PATH}/invoice/chargingForm/report`, resource , { responseType: 'blob' })
// 充電管理 -> 全單折抵設定、折抵設定查詢
const getChargingDiscount = async (resource) =>
    await axios.get(`${API_PATH}/ChargingDiscount`, { params: resource })
const postCreateChargingDiscount = async (resource) =>
    await axios.post(`${API_PATH}/ChargingDiscount`, resource)
const postUpdateChargingDiscount = async (resource) =>
    await axios.put(`${API_PATH}/ChargingDiscount`, resource)
const postDeleteChargingDiscount = async (resource) =>
    await axios.delete(`${API_PATH}/ChargingDiscount`, { data: resource })
// 充電管理 -> 充電訂單管理
const getChargeOrder = async (resource) =>
    await axios.get(`${API_PATH_V2}/detail`, { params: resource })
const getChargeOrderExport = async (resource) =>
    await axios.get(`${API_PATH_V2}/detail/export`, { params: resource , responseType: 'blob' })
const getOrderRecord = async (resource) =>
    await axios.get(`${API_PATH_V2}/detail/${resource}/record`)
const postChargingResendBonusPoint = async (resource) => // 重贈點數
    await axios.post(`${API_PATH_V2}/detail/point/readd`, resource)
const putChargingReissueInvoice = async (resource) => // 重開發票
    await axios.put(`${API_PATH_V2}/detail/${resource.uid}/reissueInvoice`, resource)
const postChargingRefund = async (resource) => {// 退款
    if (resource.payVendor === '1') {
        return await axios.post(`${API_PATH_V2}/detail/refund`, resource);
    }
    // 取消交易
    // return await axios.post(`${API_PATH}/charging/refund`, resource)
    return await axios.post(`${API_PATH}/charging/refund_amount`, resource)
}
const postChargingInvalidInvoice = async (resource) => // 作廢折讓
    await axios.put(`${API_PATH_V2}/detail/${resource.uid}/cancelInvoice`, resource)
const postChargingReturnBonus = async (resource) => // 收還點數
    await axios.post(`${API_PATH_V2}/detail/point/cancel`, resource)
export {
  getChargeReport,
  getChargeRecord,
  getChargeReportExport,
  getPaymentParameter,
  updatePaymentParameter,
  getCpo,
  createCpo,
  updateCpo,
  deleteCpo,
  getBonus,
  postCreateBonus,
  postUpdateBonus,
  postDeleteBonus,
  importBonus,
  getChargingCpoApiLog,
  getInvoice,
  postInvoiceReport,
  getInvoiceChargingForm,
  postInvoiceChargingFormReport,
  getChargingDiscount,
  postCreateChargingDiscount,
  postUpdateChargingDiscount,
  postDeleteChargingDiscount,
  getChargeOrder,
  getChargeOrderExport,
  getOrderRecord,
  postChargingResendBonusPoint,
  putChargingReissueInvoice,
  postChargingRefund,
  postChargingInvalidInvoice,
  postChargingReturnBonus
}